"use client";

import { useLang } from "@/components/ui/lang-context";

/** The page's language, sent with a form so its server action answers in it (lib/auth/actions.ts). */
export function LangField() {
  return <input type="hidden" name="lang" value={useLang()} />;
}
